import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { layers } from "@smartsheet/design-tokens";
import { useForkRef, useResizeObserver } from "@smartsheet/lodestar-utils";
import { useState, useRef, useCallback } from "react";
import { useTooltip } from "../components/tooltip";
export var useOverflowTooltip = function useOverflowTooltip(_ref) {
  var isDisabled = _ref.isDisabled,
    elementIsOverflowing = _ref.elementIsOverflowing,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    tooltipTargetRef = _ref.tooltipTargetRef,
    placement = _ref.placement;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showOverflowTooltip = _useState2[0],
    setShowOverflowTooltip = _useState2[1];
  var elementToMeasureRefLocal = useRef(null);
  var onResize = useCallback(function () {
    if (elementToMeasureRefLocal.current) {
      setShowOverflowTooltip(elementIsOverflowing(elementToMeasureRefLocal.current));
    }
  }, [elementIsOverflowing]);
  var _useResizeObserver = useResizeObserver(onResize, {
      debounceMs: 1000,
      enabled: !isDisabled
    }),
    resizeObserverRef = _useResizeObserver.ref;
  var _useTooltip = useTooltip({
      targetRef: tooltipTargetRef,
      onBlur: onBlur,
      onFocus: onFocus,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      portalProps: {
        zIndex: layers.tooltip
      },
      placement: placement
    }),
    tooltipProps = _useTooltip.tooltipProps,
    targetProps = _useTooltip.targetProps;

  // Since the text is only elided, screen readers can still see it in the DOM.
  // We'll remove this linkage so a SR won't double-read the text AND the tooltip.
  delete targetProps["aria-describedby"];
  var elementToMeasureRef = useForkRef(resizeObserverRef, elementToMeasureRefLocal);
  return {
    showOverflowTooltip: showOverflowTooltip,
    tooltipProps: tooltipProps,
    targetProps: targetProps,
    elementToMeasureRef: elementToMeasureRef
  };
};
//# sourceMappingURL=useOverflowTooltip.js.map